import { useAuthStore } from "hooks/useAuthStore";
import { useDispatch, useSelector } from "react-redux";
import {
    getLstCursos,
    getCursoViente,
    postCursoInscripcion,
    postConfirmarInscripcion,
} from "services/inscripcionCursosService/inscripcionCursosService";
import {
    onSetLstCursos,
    onSetCursoDisponible,
    onSetCursoSeleccionado,
    onSetOpenModalInscripcion,
    onSetEnviado,
    onSetMostrarLstCursos,
    onSetInscrito,
    onSetLoadingEnviado,
    onSetIrInscripcion,
} from "store/inscripcionCursos/inscripcionCursosSlice";
import { RootState } from "store/store";
import Swal from "sweetalert2";

export const useServiceInscripcionCursos = () => {
    const { user } = useAuthStore();
    const dispatch = useDispatch();
    const {
        lstCursos,
        cursoDisponible,
        cursoSelecccionado,
        openModalInscripcion,
        enviado,
        mostrarLstCursos,
        inscrito,
        loadingEnviado,
        irInscripcion,
    } = useSelector((state: RootState) => state.inscripcionCursosSlice);

    const startGetCursos = (cveUsuario: number | null) => {
        getLstCursos(cveUsuario)
            .then(({ data }) => {
                setLstCursos(data?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const startGetCursoVigente = (cveUsuario: number | null) => {
        getCursoViente(cveUsuario)
            .then(({ data }) => {
                setCursoDisponible(data?.data);
                setInscrito(data?.data?.inscrito);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const saveInscripcionCurso = (data: []) => {
        setEnviado(false);
        setLoadingEnviado(true);
        postCursoInscripcion(data)
            .then(({ data }) => {
                startGetCursoVigente(user?.session?.cveUsuario ? user?.session?.cveUsuario : null);
                startGetCursos(user?.session?.cveUsuario ? user?.session?.cveUsuario : null);
                setOpenModalInscripcion(false);
                setLoadingEnviado(false);
                setEnviado(true);
                setMostrarLstCursos(false);
                setInscrito(true);

                if (data?.data?.folio) {
                    Swal.fire({
                        icon: "success",
                        title: "Inscripción exitosa",
                        text: `La inscripción se ha realizado correctamente. Su folio es: ${data?.data?.folio}, es importante que lo conserve. `,
                        showConfirmButton: true,
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#3085d6",
                    });
                } else {
                    Swal.fire({
                        icon: "success",
                        title: "Inscripción exitosa",
                        text: "La inscripción se ha realizado correctamente.",
                        showConfirmButton: true,
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#3085d6",
                    });
                }


            })
            .catch((err) => {
                console.log(err);
                setEnviado(true);
                setMostrarLstCursos(true);
                setInscrito(false);
                setLoadingEnviado(false);
                setOpenModalInscripcion(false);
                Swal.fire({
                    icon: "error",
                    title: "Hubo un error",
                    text: err.response.data.error_msg,
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#3085d6",
                });
            });
    };

    const startConfirmarInscripcion = (data: any) => {
        postConfirmarInscripcion(data)
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    title: "Correcto",
                    text: "Se ha confirmado la inscripción correctamente.",
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#3085d6",
                });
                setInscrito(true);
                setOpenModalInscripcion(false);
                startGetCursoVigente(user?.session?.cveUsuario ? user?.session?.cveUsuario : null);
                startGetCursos(user?.session?.cveUsuario ? user?.session?.cveUsuario : null);
            })
            .catch((err) => {
                console.log(err);
                Swal.fire({
                    icon: "error",
                    title: "Hubo un error",
                    text: err.response.data.error_msg,
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#3085d6",
                });

            });
    };

    const setLstCursos = (data: []) => dispatch(onSetLstCursos(data));
    const setCursoDisponible = (data: []) => dispatch(onSetCursoDisponible(data));
    const setCursoSeleccionado = (data: number | null) => dispatch(onSetCursoSeleccionado(data));
    const setOpenModalInscripcion = (data: boolean) => dispatch(onSetOpenModalInscripcion(data));
    const setEnviado = (data: boolean) => dispatch(onSetEnviado(data));
    const setMostrarLstCursos = (data: boolean) => dispatch(onSetMostrarLstCursos(data));
    const setInscrito = (data: boolean) => dispatch(onSetInscrito(data));
    const setLoadingEnviado = (data: boolean) => dispatch(onSetLoadingEnviado(data));
    const setIrInscripcion = (data: boolean) => dispatch(onSetIrInscripcion(data));

    return {
        // props
        lstCursos,
        cursoDisponible,
        cursoSelecccionado,
        openModalInscripcion,
        enviado,
        mostrarLstCursos,
        inscrito,
        loadingEnviado,
        irInscripcion,
        //methods
        setLstCursos,
        startGetCursos,
        startGetCursoVigente,
        saveInscripcionCurso,
        setCursoDisponible,
        setCursoSeleccionado,
        setOpenModalInscripcion,
        setEnviado,
        setMostrarLstCursos,
        setInscrito,
        setLoadingEnviado,
        setIrInscripcion,
        startConfirmarInscripcion,
    }
};